import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
/* Guards */
import { AuthGuard } from '@app/components/authentication/guards/auth.guard';

import { AdminGuard } from './components/authentication/guards/admin.guard';
import { InitialComponent } from './components/initial/initial.component';
/* Components */
import { PrivateLayoutComponent } from './shared/components/layouts/private/private-layout.component';
import { PublicLayoutComponent } from './shared/components/layouts/public/public-layout.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'initial',
        component: InitialComponent,
        data: { title: 'Welcome to Aurora', animation: 'Initial' }
      },
      {
        path: 'auth',
        loadChildren: () => import('./components/authentication/authentication.module').then(m => m.AuthenticationModule),
        data: { title: 'Authentication', animation: 'Authentication' }
      }
    ]
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
        data: { title: 'Home' }
      },
      {
        path: 'data-qc',
        loadChildren: () => import('./components/data-qc/data-qc.module').then(m => m.DataQcModule),
        data: { title: 'Data QC' }
      },
      // masking QC placeholder
      {
        path: 'spectral-overview',
        loadChildren: () => import('./components/spectral-overview/spectral-overview.module').then(m => m.SpectralOverviewModule),
        data: { title: 'Spectral Overview' },
        canActivate: [AdminGuard]
      },
      {
        path: 'mineral-id',
        loadChildren: () => import('./components/mineral-id/mineral-id.module').then(m => m.MineralIDModule),
        data: { title: 'Mineral ID' }
      },
      {
        path: 'batch',
        loadChildren: () => import('./components/batch/batch.module').then(m => m.BatchModule),
        data: { title: 'Batch' },
        canActivate: [AdminGuard]
      },
      {
        path: 'reporting',
        loadChildren: () => import('./components/reporting/reporting.module').then(m => m.ReportingModule),
        data: { title: 'Reporting' },
        canActivate: [AdminGuard]
      }
    ],
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
